<template>
  <ReassuranceItem>
    <template #icon>
      <IconQuality />
    </template>
    <template #content>
      <RevLink
        class="body-2-bold text-left underline"
        @click="openReassuranceModal"
      >
        {{ i18n(translations.freeReturn, { day: coolingOffDays }) }}

        <span v-if="warrantyDelay">
          <br />
          {{ warrantyDelay }}
        </span>
      </RevLink>
      <ReassuranceModal />
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconQuality } from '@ds/icons/IconQuality'

import { type Features } from '~/features'
import { MODAL_NAMES } from '~/scopes/product/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'
import ReassuranceModal from '../ReassuranceModal/ReassuranceModal.vue'

import translations from './ItemReassurance.translations'

withDefaults(
  defineProps<{
    warrantyDelay: string
  }>(),
  { warrantyDelay: '' },
)

const i18n = useI18n()
const { features } = useMarketplace<Features>()
const { coolingOffDays } = features

function openReassuranceModal() {
  openModal(MODAL_NAMES.REASSURANCE)
}
</script>
